import type { TableView } from "owa-mail-list-store";
import { type TableQueryType } from "owa-mail-list-store";
import type { SearchSortOrder, default as SearchTableQuery, } from "../store/schema/SearchTableQuery";
import getDisplayedSearchSortOrder from "../utils/getDisplayedSearchSortOrder";

export default function getVisibleSearchSortOrder(tableView: TableView | undefined): SearchSortOrder | undefined {
    return tableView?.tableQuery.type === 1 &&
        tableView.isInitialLoadComplete &&
        tableView.rowKeys.length > 0
        ? getDisplayedSearchSortOrder(tableView.tableQuery as SearchTableQuery)
        : undefined;
}
